import { PreviewPostPage } from '@/src/components/previewPages/previewPostPage/PreviewPostPage';
import PreviewProvider from '@/src/components/providers/previewProvider/PreviewProvider';
import { Post } from '@/src/components/screens/Post/Post';
import { GetStaticPropsContext } from 'next';
import Link from 'next/link';
import { ParsedUrlQuery } from 'querystring';
import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';

import { getBlogPostData } from '@/src/api/api';

import Custom404 from '../../404';

interface PathParams extends ParsedUrlQuery {
    slug: string;
}

interface PostPageProps {
    blogPostData: BlogPostInterface | null;
    preview: boolean;
    previewToken: string;
    slug: string;
}

const PostPage: FC<PostPageProps> = ({ blogPostData, preview, previewToken, slug }) => {
    if (!blogPostData) {
        return <Custom404 />;
    }

    if (preview && previewToken) {
        return (
            <PreviewProvider previewToken={previewToken}>
                <PreviewPostPage data={blogPostData} slug={slug} />
                <Link className="exit-preview" href={'/api/exit-preview'}>
                    EXIT PREVIEW
                </Link>
            </PreviewProvider>
        );
    }
    return <Post post={blogPostData} />;
};

export async function getServerSideProps(context: GetStaticPropsContext<PathParams>) {
    const preview = context.draftMode || false;
    const previewToken = preview ? process.env.SANITY_API_READ_TOKEN : ``;

    if (preview && !previewToken) {
        throw new Error(
            `Preview mode is active, but SANITY_API_READ_TOKEN is not set in environment variables`
        );
    }

    if (!context.params?.slug) {
        throw new Error('No slug!');
    }

    const blogPostData = await getBlogPostData({
        previewToken: previewToken,
        slug: context.params.slug,
    });

    return {
        props: {
            blogPostData,
            preview,
            previewToken,
            slug: context.params?.slug,
        },
    };
}

export default PostPage;
